import { useContext } from "react";
import MetadataContext from "../../Context/metadataContext";

export function useSearchQueries() {
  const { metadata } = useContext(MetadataContext);

  if (metadata.domainText === "Breez") {
    return {
      frequentSearches: [
        "Marketing",
        "Graphic Designer",
        "React Developer",
        "Customer Support",
        "Sales",
        "HR Specialist",
        "Technical Recruiter",
      ],
      frequentPhrases: [
        "React developers with 3+ years experience",
        "Remote customer support specialists",
        "B2B SaaS sales representatives",
        "Technical recruiters in North America",
        "Graphic designers with Figma expertise",
        "HR specialists with startup experience",
        "Frontend engineers skilled in React and TypeScript",
      ],
    };
  }
  if (metadata.domainText === "Bizgraph") {
    return {
      frequentSearches: [
        "Manufacturing",
        "Robotics",
        "Real Estate",
        "Logistics",
        "Autonomous Driving",
        "Hydraulic Press",
        "Electric Door Handles",
      ],
      frequentPhrases: [
        "Find robotics companies in North America",
        "Supplier of electric door handles",
        "Autonomous driving technology companies",
        "Real estate software providers",
        "Food processing equipment suppliers",
        "Custom CNC machining companies",
      ],
    };
  }
  return {
    frequentSearches: null,
    frequentPhrases: null
  }
}
